import React, { useState } from 'react';
import './index.css';
import { Image } from '../../assets';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';

const NAV_ITEMS = [
  { label: 'Home', target: 'Home' },
  { label: 'About Us', target: 'aboutus' },
  { label: 'Our Services', target: 'ourservices' },
  { label: 'Portfolio', target: 'portfolio' },
  { label: 'Contact Us', target: 'footer' },
];

const Navbar = () => {
  const navigation = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const goToSection = (elementId) => {
    setMenuOpen(false);
    const scrollTo = () => {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    if (window.location.pathname !== '/') {
      navigation('/');
      setTimeout(scrollTo, 300);
    } else {
      scrollTo();
    }
  };

  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        <button
          type="button"
          className="navbar-brand"
          onClick={() => goToSection('Home')}
          aria-label="Ayan Tech home"
        >
          <div className="Navaling">
            <img src={Image} alt="Ayan Tech logo" className="LogoStyles2" />
          </div>
        </button>

        <div className="Laptop-view-navbar">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.label}
              type="button"
              className="nav-link text-with-shadow"
              onClick={() => goToSection(item.target)}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Mobile menu toggle */}
        <button
          type="button"
          className="menue-Icon mobile-view-dropdown"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <CloseIcon htmlColor="#FFF" /> : <MenuIcon htmlColor="#FFF" />}
        </button>
      </div>

      {menuOpen && (
        <ul className="mobile-menu">
          {NAV_ITEMS.map((item) => (
            <li key={item.label}>
              <button
                type="button"
                className="mobile-menu-item"
                onClick={() => goToSection(item.target)}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
